const VIETNAMESE = 'vietnamese'
const ENGLISH = 'english'

export { VIETNAMESE, ENGLISH }
